import { Component, Input } from '@angular/core';
import { Website } from 'src/app/pages/teacher-page/models/interfaces/website';

@Component({
  selector: 'app-website-card',
  templateUrl: './website-card.component.html',
  styleUrls: ['./website-card.component.css']
})
export class WebsiteCardComponent {
  @Input() site!: Website;
  @Input() isActive = false;
}
